import { useState } from "react";
import {
	Divider,
	IconButton,
	List,
	type ListItemProps,
	Searchbar,
	type SearchbarProps,
} from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export interface SearchViewFullscreenProps extends SearchbarProps {
	items: (ListItemProps & { numberOfLines?: number })[];
	onItemClick?: (item: ListItemProps) => void;
	showCloseIcon?: boolean;
	rightIcon?: string;
}

const SearchViewFullscreen = ({
	items = [],
	onItemClick,
	onChangeText,
	showCloseIcon = true,
	defaultValue = "",
	rightIcon = "close",
	...props
}: SearchViewFullscreenProps) => {
	const theme = useAppTheme();
	const [_searchQuery, setSearchQuery] = useState(defaultValue);

	const handleChange = (text: string) => {
		setSearchQuery(text);
		onChangeText?.(text);
	};

	const handleClear = () => {
		setSearchQuery("");
		onChangeText?.("");
	};

	return (
		<Box width="100%">
			<Box
				style={{
					backgroundColor: theme.colors.surfaceVariant,
				}}
			>
				<Searchbar
					theme={{
						...theme,
						colors: {
							...theme.colors,
						},
					}}
					right={(props) =>
						showCloseIcon && (
							<IconButton
								onPress={() => handleClear()}
								{...props}
								icon={rightIcon}
							/>
						)
					}
					placeholderTextColor={theme.colors.onSurfaceVariant}
					inputStyle={{
						color: theme.colors.onSurface,
					}}
					onChangeText={handleChange}
					style={{
						backgroundColor: theme.colors.surfaceVariant,
						borderRadius: 0,
					}}
					{...props}
				/>
			</Box>
			{items.length > 0 && <Divider />}

			{items.length > 0 &&
				items.map((item) => (
					<List.Item
						key={item.id}
						{...item}
						style={[
							{
								paddingHorizontal: 16,
								paddingVertical: 8,
								flex: 1,
								backgroundColor: theme.colors.surfaceVariant,
							},
							item.style,
						]}
						onPress={() => onItemClick?.(item)}
					/>
				))}
		</Box>
	);
};

export default SearchViewFullscreen;
